import { useEffect, useState } from 'react'
import { Button } from './UI'

const STORAGE_KEY = 'proffer_analytics_consent'

export function getAnalyticsConsent(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'granted'
  } catch {
    return false
  }
}

export function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(STORAGE_KEY) === null)
    } catch {
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'granted')
    } catch {
      /* ignore */
    }
    setVisible(false)
  }

  const decline = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'denied')
    } catch {
      /* ignore */
    }
    setVisible(false)
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-zinc-200 bg-white/95 p-4 shadow-lg backdrop-blur dark:border-zinc-800 dark:bg-zinc-950/95"
      role="dialog"
      aria-label="Συγκατάθεση cookies"
    >
      <div className="mx-auto flex max-w-4xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-zinc-700 dark:text-zinc-300">
          Χρησιμοποιούμε αναλυτικά γεγονότα πρώτου μέρους για βελτίωση του ProfferAI. Δείτε την{' '}
          <a href="/privacy" className="font-semibold text-violet-600 underline">
            πολιτική απορρήτου
          </a>
          .
        </p>
        <div className="flex shrink-0 gap-2">
          <Button type="button" variant="secondary" onClick={decline}>
            Απόρριψη
          </Button>
          <Button type="button" onClick={accept}>
            Αποδοχή
          </Button>
        </div>
      </div>
    </div>
  )
}
